import React from 'react'
import { useEffect ,useState} from 'react'
import NavBarLeft from '../../ReusableComp/NavBarLeft'
import NavigationBar from '../../ReusableComp/NavigationBar'
import axios from "axios";
import { base_url } from '../../../utilities';
import { Col, Container, Modal, Row, Stack, Table } from "react-bootstrap";
import { useDispatch,useSelector } from 'react-redux';
import Loader from '../../ReusableComp/Loader';
import { Tooltip } from 'react-tooltip'
import {
  getPmsStudyData,
  getNewPmsStudyData,
  getConcludedData
} from "../../../Redux/actions/actions";

const PMSAdminCIOMSreports = () => {

  const qrSubjectList = useSelector((state) => state.pmsConcludedData);
  const subjectCounts = useSelector((state) => state.qrSubjectsRelatedcounts);
  const studyId = localStorage?.getItem("study_id")

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState("");
  let   [loading_flag, Setloading_flag] = useState(false);
  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [ciomsData,setCiomsData]=useState([]);
  const [subjectCode,setSubjectCode]=useState();
  const [loading,setLoadingg]=useState(false);
  const [ciomsUrl,setCiomsUrl]=useState();
  useEffect(()=>{
    dispatch(getPmsStudyData())
    dispatch(getNewPmsStudyData())
  },[dispatch])


  useEffect(() => {
    Setloading_flag(true);
    if(qrSubjectList){
      setFilteredData(qrSubjectList);
      setTimeout(() => {
        Setloading_flag(false);
      }, 600);
    }
  }, [dispatch,qrSubjectList !== null,localStorage.study_id]);

  useEffect(() => {
    if (qrSubjectList) {
      setFilteredData(qrSubjectList)
    }
  },[qrSubjectList])

  const dashboardCards = [
    {
      count: filteredData?.length,
      image: "./images/icons/subjects_white.svg",
      desc: "Total concluded subjects",
      bgcolor: "#8DA2B5",
      textColor: "white",
    },
  ];


  const handleSearchData = (event) => {
    const searchText = event.target.value?.toLowerCase();
    setSearchText(searchText);
    const filteredData = qrSubjectList?.filter((item) => {
      const { subject_code , site_name} = item;

      const formattedSubjectCode = subject_code?.toLowerCase();
      const formattedSiteName = site_name ? site_name.toLowerCase() : ""

      return (
        formattedSubjectCode.includes(searchText) ||
        formattedSiteName.includes(searchText)
      );
    });

    setFilteredData(filteredData);
  };

  const handleAscending = () => {
    setAsC(true);
    setDesc(false);
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeA.localeCompare(subjectCodeB);
    });
    setFilteredData(sortedData);
  };
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });
    setFilteredData(sortedData);
  };

  let rolecode = localStorage.getItem('role_code')

  const handleSubjectData = (data,subject_code) => {
    setStudyDropdwn(true);
    setCurrentPage(2);
    setLoadingg(true);
    setSubjectCode(subject_code);
    getCiomsReports(data);
  }

  const getCiomsReports=(data)=>{
    axios
    .post(base_url + "cioms/fetch_cioms_details",{
      "subject_id":data
    })
    .then((res) => {
        setCiomsData(res.data.data);
        setTimeout(()=>{
          setLoadingg(false);
        },200);
    })
    .catch((err) => {
      console.log(err);
    });
  }

  const handleBackClick = () => {
    setCurrentPage(1)
    setStudyDropdwn(false);
}


const fetchImages = async (document_url) => {
      if (document_url != null && document_url !== '') {
      setLoadingg(true)
        const queryParams = `?url=${document_url}`;
        const response = await fetch(base_url + 'api/getImage' + queryParams);
        const data = await response.arrayBuffer();
        const base64 = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        //document_url = `data:${response.headers.get('content-type')};base64,${base64}`;
        // return document_url;
        setCiomsUrl(`data:${response.headers.get('content-type')};base64,${base64}`)
        setLoadingg(false)
        return `data:${response.headers.get('content-type')};base64,${base64}`
      }
};

// const downloadFile =async  (document_url,typeOfDoc,report_name) => {
//   await fetchImages(document_url);
//   if(ciomsUrl!==undefined || ciomsUrl!==null){   
//   const validDocumentTypes = ["pdf"];
//   if (validDocumentTypes.includes(typeOfDoc)) {
//   fetch(ciomsUrl)
//   .then(response => response.blob())
//   .then(blob => {
// // Create a Blob from the binary data
// const blobUrl = window.URL.createObjectURL(blob);

// // Create a download link and trigger a click event
// const downloadLink = document.createElement('a');
// downloadLink.href = blobUrl;
// downloadLink.download = report_name; // Set the desired file name
// downloadLink.click();

// // Clean up the URL.createObjectURL
// window.URL.revokeObjectURL(blobUrl);
// })
// .catch(error => {
// console.error('Error fetching file:', error);
// });
// }

//   }
// } ----- commented by dinesh as the downloaded cioms file after first click is not happening properly.

const downloadFile = async (document_url, typeOfDoc, report_name) => {
  // Fetch images from the document_url (not provided in the code snippet)
  const cioms_Url = await fetchImages(document_url);
  // await new Promise(resolve => setTimeout(resolve, 3000));
  // Check if ciomsUrl is defined or not
  if (cioms_Url) {
    // Define valid document types (in this case, only "pdf" is considered valid)
    const validDocumentTypes = ["pdf"];
    // Check if the specified document type is valid
    if (validDocumentTypes.includes(typeOfDoc)) {
      try {
        // Fetch the file from ciomsUrl
        const response = await fetch(cioms_Url);
        if (!response.ok) {
          throw new Error(`Failed to fetch file. HTTP status: ${response.status}`);
        }
        // Convert the response to a blob
        const blob = await response.blob();
        // Create a Blob from the binary data
        const blobUrl = window.URL.createObjectURL(blob);
        // Create a download link and trigger a click event
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = report_name; // Set the desired file name
        // Append the download link to the document body
        document.body.appendChild(downloadLink);
        // Trigger a click event
        downloadLink.click();
        // Remove the download link from the document body
        document.body.removeChild(downloadLink);
        // Clean up the URL.createObjectURL
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('Error fetching or downloading file:', error);
      }
    }
  }
};
const downloadXMLFile = async (document_url,typeOfDoc,report_name) => {
    // Fetch images from the document_url (not provided in the code snippet)
    const cioms_Url = await fetchImages(document_url);
    // await new Promise(resolve => setTimeout(resolve, 3000));
    // Check if ciomsUrl is defined or not
    if (cioms_Url) {
      // Define valid document types (in this case, only "pdf" is considered valid)
      const validDocumentTypes = ["xml"];
      // Check if the specified document type is valid
      if (validDocumentTypes.includes(typeOfDoc)) {
        try {
          // Fetch the file from ciomsUrl
          const response = await fetch(cioms_Url);
          if (!response.ok) {
            throw new Error(`Failed to fetch file. HTTP status: ${response.status}`);
          }
          const blob = await response.blob();
          // Create a Blob from the binary data
          const blobUrl = window.URL.createObjectURL(blob);
          // Create a download link and trigger a click event
          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.download = report_name; // Set the desired file name
          // Append the download link to the document body
          document.body.appendChild(downloadLink);
          // Trigger a click event
          downloadLink.click();
          // Remove the download link from the document body
          document.body.removeChild(downloadLink);
          // Clean up the URL.createObjectURL
          window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
              console.error('Error fetching or downloading file:', error);
            }
          }
    }else{
    }
}

const getDate=(date)=>{
  const utcDate = new Date(date);
  // Convert to India Standard Time (IST)
  utcDate.setHours(utcDate.getHours() + 5); // Add 5 hours to UTC time
  utcDate.setMinutes(utcDate.getMinutes() + 30); // Add 30 minutes to UTC time
  // Format the IST date and time
  const istDate = utcDate.toISOString().slice(0, 10); // Extract the date part (YYYY-MM-DD)
  const istTime = utcDate.toISOString().slice(11, 16); // Extract the time part (HH:MM:SS)
  // Split the date string into an array of its components
  const dateArray = istDate.split('-');

  // Reverse the array
  const reversedDateArray = dateArray.reverse();

// Join the reversed array back into a string
  const reversedDate = reversedDateArray.join('-');
  
  return `${reversedDate + " " + istTime}`;
 }

  return (
    <div>
      <NavigationBar 
        studyDropdwn={studyDropdwn}
        title={"CIOMS Reports"}
        rolecode={rolecode}
        />
        <div className='main_body'>
        {currentPage === 1 && (
        <Container fluid className="pt-4 ">
              <Stack className="add_subject_stack ps-0">
                <div className="">
                  <Row className="row d-flex w-25">
                    {dashboardCards?.map((card, index) => {
                      return (
                        <Col key={index}>
                          <div
                            className="card-container"
                            style={{ backgroundColor: card.bgcolor }}
                          >
                            <div
                              className="content"
                              style={{ color: card.textColor }}
                            >
                              <span>{card.count}</span>
                              <img src={card.image} alt="" />
                            </div>
                            <div
                              className="desc"
                              style={{ color: card.textColor }}
                            >
                              {card.desc}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Stack>
              {qrSubjectList && qrSubjectList?.length > 0 ? (
                <Container fluid className="pitable_container mt-2  ">
                  <Row className='searchbar'>
                    <Col className='searchFiled gap-3'>
                      <label htmlFor="" />
                      <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with Subject ID' onChange={handleSearchData} />
                      <div className=" ">
                      </div>

                    </Col>
                  </Row>

                  <div>
                    {loading_flag ? (
                      <div className=''>
                        <img
                          className="atrium_loader"
                          src="/images/circle-effect-loading.gif"
                          alt="Loader"

                        />
                      </div>

                    ) : (
                      <div className="table-scroll-container " style={{ border: "1px solid #E1E5E7 " }}>
                        {filteredData?.length > 0 ?
                          <Table bordered size="sm" className="pitable mb-0">
                            <thead className='sticky_table_header'>
                              <tr>
                                <th> S.No</th>
                                <th className="sticky-header">
                              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Subject ID</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                        </th>

                                <th style={{ minWidth: "145px" }}>
                                  Sex
                                  
                                </th>
                                <th>
                                 Initials
                                  
                                </th>
                                <th>
                                  Events
                                  
                                </th>
                             
                                <th>Concluded on </th>
                                <th>Actions</th>
                              </tr>
                            </thead>

                            <tbody className="tableBodyScroll ">
                              {filteredData?.map((i, index) => {
                                return (
                                  <tr key={i?.index} className="text_left_table">
                                    <td className='text_right_sno'> {index + 1} </td>
                                    <td>{i?.subject_code}</td>
                                    <td>{i?.sex}</td>
                                    {/* <td>{i.site_name}</td> */}
                                    <td>{i?.last_name}</td>
                                    <td>{i?.events_reported}</td>
                                    <td>{getDate(i?.updatedAt)}</td>
                                
                                    <td className="viewbtnstyl">
                                    <button
                                      className="gray_btn px-3"
                                      onClick={() => handleSubjectData(i?.subject_id,i?.subject_code)}
                                    >
                                      View reports
                                    </button>{" "}
                                  </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                          :
                          <div className="bg-white border py-4 text-center">No records found with search criteria</div>

                        }
                      </div>
                    )}
                  </div>
                </Container>
              ) : (
                <>
                 {loading_flag ? (
                     <div className=''>
                     <img
                       className="atrium_loader"
                       src="/images/circle-effect-loading.gif"
                       alt="Loader"

                     />
                   </div>
                ) :  qrSubjectList === null ? <div className=''>
                        <img
                            className="atrium_loader"
                            src="/images/circle-effect-loading.gif"
                            alt="Loader"

                        />
                      </div> : (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                    <img src="./images/no_subjects.svg" alt="Telephone" />
                    <h5> No Concluded Subjects Found </h5>
                  </div>
                )}
                </>
              )}
            </Container>
              )}
        {currentPage === 2 && (
           <Container fluid className="pt-2 page_two_styl" >
             <Row className='d-flex justify-content-between'>
                    <Col><button className="white_btn white_btn_back" onClick={handleBackClick}>{'< '}Back</button> </Col>
                </Row>
                <Container fluid className='py-3 '>
                    <Row className='viewPage'>
                                <div style={{ margin: "24px 24px" }} className='d-flex justify-content-between'>
                                  <div>
                                    <p style={{ fontWeight: "bold", color: "black", fontSize:"20px"}}>Subject code:{subjectCode && subjectCode} </p>
                                    <span  style={{border: "1px dotted #E1E5E7",color:"red"}}>{ciomsData && ciomsData.event_level_report===0 ? "Subject level report":"Event level reports"}</span>
                                  </div>
                                  {ciomsData?.event_cioms?.length>0 && <span className='mx-5'>
                                                                          <span>Download CIOMS XML Report</span>
                                                                          <img
                                                                            src="./images/icons/XML_Icon.svg"  // Replace with the actual path to your PDF icon
                                                                            alt="PDF Icon"
                                                                            onClick={() => downloadXMLFile(ciomsData?.event_cioms[0]?.xmlreport_url,"xml",`${ciomsData?.event_cioms[0]?.report_name.split("_")[0]}_${subjectCode}.xml`)}
                                                                            style={{ cursor: "pointer", width: "40px", height: "35px", marginRight: "10px" }}
                                                                          />
                                                                        </span>}
                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "24px", marginRight: "24px", width:"85vw"}}></div>
                                
                                <div style={{ display: "flex", flexDirection: "row", margin: "24px 24px 0px 24px", justifyContent: "start", alignItems:"center"}}>

                                    <p style={{marginRight:"20px"}}>
                                    {ciomsData?.event_level_report === 0
                                        ? `List of subject reports: ${ciomsData?.subject_cioms?.length}`
                                        : `List of event reports: ${ciomsData?.event_cioms?.length }`}
                                    </p>
                      
                            </div>
                           
                               
                                <div style={{marginBottom:"32px"}}>
                                <Table bordered size="sm" className='pitable mb-0' style={{width:"85vw",marginLeft:"25px"}}>
                            <thead className='sticky_table_header' style={{height:window.scrollY> 50 ?"105px" :""}}>
                                <tr>
                                    <th>{ciomsData && ciomsData.event_level_report===0 ? "#":"Event Name"}</th>
                                    <th>Report Name</th>
                                    <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody >
                                    {ciomsData && ciomsData.event_level_report === 0 && ciomsData.subject_cioms?.map((i,index) => {
                                          return (
                                              <tr key={index +1} className='text_center_table'> {/* Assuming there's an 'id' property in the subject_cioms object */}
                                                  <td>
                                                  {"Subject"}
                                                  </td>
                                                  <td data-tooltip-id={i?.report_name} data-tooltip-content={i?.report_name} >
                                                      {i?.report_name?.length > 40
                                                          ? i?.report_name.slice(0, 40) + "...."
                                                            : i?.report_name}
                                                  <Tooltip id={i?.report_name} className='tooltip_study' style={{zIndex:10}}/>
                                                  </td>
                                                  <td>
                                                  <img height="30px" width="40px" src='./images/icons/reshot-icon-pdf.svg' title='Click on the icon to download the file' style={{ cursor: "pointer" }}  onClick={() => {downloadFile(i?.report_url,'pdf',i?.report_name)}} />
                                                  </td>
                                              </tr>
                                          );
                                      })}

                                    {ciomsData && ciomsData.event_level_report === 1 && ciomsData?.event_cioms?.map((i,index) => {
                                          return (
                                              <tr key={index +1} className='text_center_table'> {/* Assuming there's an 'id' property in the subject_cioms object */}
              
                                                  <td data-tooltip-id={i?.event_name} data-tooltip-content={i?.event_name} >
                                                      {i?.event_name?.length > 40
                                                          ? i?.event_name.slice(0, 40) + "...."
                                                            : i?.event_name}
                                                  <Tooltip id={i?.event_name} className='tooltip_study' style={{zIndex:10}}/>
                                                  </td>
                                                  <td data-tooltip-id={i?.report_name} data-tooltip-content={i?.report_name} >
                                                      {i?.report_name?.length > 40
                                                          ? i?.report_name.slice(0, 40) + "...."
                                                            : i?.report_name}
                                                  <Tooltip id={i?.report_name} className='tooltip_study' style={{zIndex:10}}/>
                                                  </td>
                                                  <td>
                                                  <img height="30px" width="40px" src='./images/icons/reshot-icon-pdf.svg' title='Click on the icon to download the file' style={{ cursor: "pointer" }}  onClick={() => {downloadFile(i?.report_url,'pdf',i?.report_name)}} />
                                                  </td>
                                              </tr>
                                          );
                                      })}

                                    </tbody>
                                </Table>
                                </div>
                    </Row>
                    
                </Container>
            
           </Container>
        )}
        {loading && <Loader />}
                              </div>
    </div>
  )
}

export default PMSAdminCIOMSreports
